import { useRef, useState } from "react";
import { fileUrl } from "@/lib/api";
import { Play, Pause } from "lucide-react";

function fmt(s) {
  s = Math.max(0, Math.round(s || 0));
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

// Compact audio message player + transcript, used in both patient and counselor threads.
export default function AudioBubble({ fileId, duration, transcript, mine }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (playing) a.pause();
    else a.play();
  };
  const btn = mine ? "bg-white text-[#0F766E]" : "bg-[#0F766E] text-white";
  const bar = mine ? "bg-white/70" : "bg-[#0F766E]/60";
  return (
    <div data-testid={`audio-bubble-${fileId}`}>
      <div className="flex items-center gap-3">
        <button onClick={toggle} data-testid={`audio-play-${fileId}`}
          className={`w-9 h-9 rounded-full grid place-items-center shrink-0 ${btn}`}>
          {playing ? <Pause size={16} /> : <Play size={16} />}
        </button>
        <div className="flex items-end gap-[3px] h-6 flex-1 min-w-[90px]">
          {[8, 14, 20, 12, 18, 10, 22, 14, 9, 16, 12, 7].map((h, i) => (
            <span key={i} className={`w-[3px] rounded-full ${bar}`} style={{ height: `${h}px` }} />
          ))}
        </div>
        <span className={`text-xs tabular-nums ${mine ? "text-white/80" : "text-[#1F3B4D]/70"}`}>{fmt(duration)}</span>
      </div>
      {transcript ? (
        <div className={`mt-2 text-sm whitespace-pre-wrap ${mine ? "text-white/90" : "text-[#1F3B4D]"}`}>{transcript}</div>
      ) : null}
      <audio ref={ref} src={fileUrl(fileId)} preload="none" className="hidden"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
    </div>
  );
}
